import BreakingDeals from '../../../../components/containers/BreakingDealsContainer';
import preloadCustomProps from '../../../utils/preloads/preloadBreakingDealsProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'breaking-deals',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: BreakingDeals
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
